import React, { useState } from "react";
import { dataSlider } from "../../data/dataSlider";
import { BiCaretLeft, BiCaretRight } from "react-icons/bi";
import { useEffect } from "react";
const Slideshow = ({ setCategory }) => {
  const [slideIndex, setSlideIndex] = useState(1);
  let nextCat = [];
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, [10000]);
    return () => clearInterval(interval);
  });
  const moveDot = (index, category) => {
    setSlideIndex(index);
    setCategory(category);
  };
  const nextSlide = () => {
    if (slideIndex !== dataSlider.length) {
      setSlideIndex(slideIndex + 1);
      setCategory(nextCat[slideIndex]);
    } else if (slideIndex === dataSlider.length) {
      setSlideIndex(1);
      setCategory(nextCat[0]);
    }
  };
  //   const prevSlide = () => {
  //     if (slideIndex !== 1) {
  //       setSlideIndex(slideIndex - 1);
  //     } else if (slideIndex === 1) {
  //       setSlideIndex(dataSlider.length);
  //     }
  //   };

  return (
    <div className="slide-container">
      {dataSlider.map((data, index) => {
        nextCat.push(data.category);
        return (
          <React.Fragment key={data.id}>
            <div
              className={
                slideIndex === index + 1 ? "slide active-anim " : "slide"
              }
            >
              <div className="image">
                <img src={data.img} alt={data.img} />
              </div>

              {/* <div className="course-container">
                <h2>{data.type}</h2>
                <h3>{data.title}</h3>
                <h3>{data.source}</h3>
                {data.deployed && (
                  <a href={data.deployed} target="_blank" rel="noreferrer">
                    <FaRocket className="icon" /> Deployed Link
                  </a>
                )}
                {data.repo && (
                  <a href={data.repo} target="_blank" rel="noreferrer">
                    <BiLink className="icon" /> Github Repository
                  </a>
                )}
              </div> */}
            </div>
          </React.Fragment>
        );
      })}
      {/* <div className="arrows">
        <BiCaretLeft onClick={() => prevSlide()} className="leftArrow" />
        <BiCaretRight onClick={() => nextSlide()} className="rightArrow" />
      </div> */}
      <div className="container-dots">
        {dataSlider.map((item, index) => (
          <div
            key={index}
            onClick={() => moveDot(index + 1, item.category)}
            className={slideIndex === index + 1 ? "dot active" : "dot"}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default Slideshow;
